/** Formatação numérica em pt-BR (vírgula decimal), espelhando o protótipo. */

export function pct(x: number | null): string {
  return x === null ? "—" : `${(x * 100).toFixed(1).replace(".", ",")}%`;
}

export function num1(x: number | null): string {
  return x === null ? "—" : x.toFixed(1).replace(".", ",");
}

export function num2(x: number | null): string {
  return x === null ? "—" : x.toFixed(2).replace(".", ",");
}
